import _ from 'lodash';
import { customerDashboardTypesForms, withdrawalBalanceTypesForms } from './forms.types';
import { customerAccountDetailsTypes, withdrawalBalanceSteps } from 'constants/customer-account.constants';
import { store } from 'state/store';
import { SupportType, pendingRequestsTypes } from 'constants/requests.constants';
import { BalanceType } from 'constants/balance.constants';
import { BankAccountStatus } from 'constants/bank-account.constants';
import { fieldMode, validationTypes } from 'components/FormCreatorComponent/types';
import { PaymentStatus, PaymentStatusHebrew } from 'constants/payment.constants';
import { getPaymentCategoryDisplayById } from 'services/payment-categories.service';

export function getFormsValuesByType(
	record: Record<string, any>,
	type = '',
	permissionToChangeStatus: boolean,
	countryOptions: any[] | null,
	setOpenRefundPopup?: any,
	isRefundReady?: boolean,
	coinWithDecimalNotAllowedChosen?: boolean
) {
	const forms = _.get(customerDashboardTypesForms, _.camelCase(type));
	const obj: Record<string, any> = {};
	const altshulerAccount = { altshulerAccount: record?.altshulerAccount };

	// Flatten files structure for beneficiaries and payments - extract nested file objects
	const flattenedFiles: Record<string, any> = {};
	if (record.files && Array.isArray(record.files)) {
		record.files.forEach((fileWrapper: any, index: number) => {
			if (fileWrapper.file) {
				flattenedFiles[`files[${index}]`] = fileWrapper.file;
			}
		});
	}
	if (!_.isNil(_.get(record, 'finalAltshulerTransferAccountId'))) {
		const altshulerAccountsList = store.getState().global.altshulerAccountList || [];
		altshulerAccount.altshulerAccount = _.find(altshulerAccountsList, {
			id: _.get(record, 'finalAltshulerTransferAccountId'),
		});
	}

	forms.forEach((form, formIdx) => {
		form.fieldsGroups.forEach((group, groupIdx) => {
			group.fields.forEach((field, fieldIdx) => {
				const value = _.get({ ...record, ...altshulerAccount, ...flattenedFiles }, field.props.name, '');
				_.assign(obj, { [field.props.name]: value });
				if (field.props.name === 'status' && !permissionToChangeStatus) {
					field.mode = fieldMode.readonly;
				}
				if (field.props.name === 'country' && countryOptions) {
					field.props.options = countryOptions;
				}
				if (field.props.name === 'rejectReason' && _.isEmpty(value)) {
					_.assign(obj, { boNotes: _.get(record, 'boNotes') });
				}
				if (_.has(record, 'currency.symbol')) {
					_.assign(obj, { symbol: _.get(record, 'currency.symbol') });
				}
				if (field.props.name === 'referenceActionIdentity') {
					_.assign(obj, { referenceActionType: _.get(record, 'referenceActionType') });
				}
				if (field.props.name === 'boNotes') {
					_.assign(obj, {
						boNotes: _.get(
							record,
							'beneficiaryDeniedMessages[0].translation[0].he',
							_.get(record, 'boNotes')
						),
					});
				}
				if (
					_.camelCase(type) === customerAccountDetailsTypes.PAYMENT &&
					field.props.name === 'boApprovalDate'
				) {
					_.assign(obj, { [field.props.name]: record['boApprovalDate'] });
				}
				if (
					_.camelCase(type) === customerAccountDetailsTypes.PAYMENT &&
					field.props.name === 'refund.create.amount'
				) {
					if (coinWithDecimalNotAllowedChosen) {
						field.validation = [
							{ [validationTypes.noDecimalAllowed]: true },
							{ [validationTypes.requierd]: true },
						];
					} else {
						field.validation = [{ [validationTypes.integer]: true }, { [validationTypes.requierd]: true }];
					}
				}
				if (
					_.camelCase(type) === customerAccountDetailsTypes.PAYMENT &&
					field.props.name === 'refund.create.amount'
				) {
					if (coinWithDecimalNotAllowedChosen) {
						field.validation = [
							{ [validationTypes.noDecimalAllowed]: true },
							{ [validationTypes.requierd]: true },
						];
					} else {
						field.validation = [{ [validationTypes.integer]: true }, { [validationTypes.requierd]: true }];
					}
				}
				if (_.camelCase(type) === customerAccountDetailsTypes.PAYMENT) {
					// Compute payment category display
					if (field.props.name === 'paymentCategoryDisplay') {
						_.assign(obj, {
							paymentCategoryDisplay: getPaymentCategoryDisplayById(record.paymentCategoryId),
						});
					}
					if (field.props.name.includes('status')) {
						const isFeeStatus = field.props.name.includes('fee');
						const status = isFeeStatus ? record['fee.statusHebrew'] : record.statusHebrew;

						if (
							[
								PaymentStatusHebrew.Approved,
								PaymentStatusHebrew.Completed,
								PaymentStatusHebrew.AwaitingFunds,
								PaymentStatusHebrew.AwaitingAltshulerAuthorization,
							].includes(String(status ?? '') && !field.props.name.includes('refund'))
						) {
							field.mode = fieldMode.readWithEnableWrite;
							field.props.disabled = false;
						}
						switch (status) {
							case PaymentStatusHebrew.Approved: {
								field.props.value = {
									label: PaymentStatusHebrew.Approved,
									value: PaymentStatus.Approved,
								};
								field.props.options = [
									{ label: PaymentStatusHebrew.Completed, value: PaymentStatus.Completed },
									{ label: PaymentStatusHebrew.Failed, value: PaymentStatus.Failed },
								];

								break;
							}
							case PaymentStatusHebrew.Completed: {
								field.props.value = {
									label: PaymentStatusHebrew.Completed,
									value: PaymentStatus.Completed,
								};
								field.props.options = [
									{ label: PaymentStatusHebrew.Failed, value: PaymentStatus.Failed },
								];
								break;
							}

							case PaymentStatusHebrew.AwaitingFunds: {
								field.props.value = {
									label: PaymentStatusHebrew.AwaitingFunds,
									value: PaymentStatus.AwaitingFunds,
								};
								field.props.options = [
									{ label: PaymentStatusHebrew.Completed, value: PaymentStatus.Completed },
									{ label: PaymentStatusHebrew.Failed, value: PaymentStatus.Failed },
								];
								field.mode = fieldMode.readWithEnableWrite;
								break;
							}
							case PaymentStatusHebrew.AwaitingAltshulerAuthorization: {
								field.props.value = {
									label: PaymentStatusHebrew.AwaitingAltshulerAuthorization,
									value: PaymentStatus.AwaitingAltshulerAuthorization,
								};
								field.props.options = [
									{ label: PaymentStatusHebrew.Completed, value: PaymentStatus.Completed },
									{ label: PaymentStatusHebrew.Failed, value: PaymentStatus.Failed },
								];
								break;
							}
							default: {
								field.props.disabled = true;
								field.mode = fieldMode.readonly;
								break;
							}
						}
					}

					if (field.props.name === 'refund.create.currencyId') {
						field.props.options =
							store.getState().balance.houseBalances?.map((item: any) => ({
								value: item.currency.id,
								label: item.currency.name,
							})) ?? [];
					}
					switch (field.props.name) {
						case 'refund.create.currencyId':
						case 'refund.create.amount':
						case 'refund.create.note':
							field.mode = permissionToChangeStatus ? fieldMode.write : fieldMode.readonly;
							field.props.disabled = !permissionToChangeStatus;
							break;
						case 'refund.create.create_button':
							if (permissionToChangeStatus) {
								field.mode = fieldMode.readonly;
								field.props.disabled = !isRefundReady;
								field.handleClick = () => setOpenRefundPopup(true);
							} else {
								field.props.disabled = true;
							}
							break;
						default:
							break;
					}
				}
				if (field.props.name === 'pendingQuote.finalRate' && _.isNil(_.get(record, 'pendingQuote.finalRate'))) {
					obj['pendingQuote.finalRate'] = _.get(record, 'pendingQuote.coreRate');
				}
			});
		});
	});
	return obj;
}

export const updateFieldProperties = (
	field: any,
	permissionToChangeStatus: boolean,
	isFormValid: boolean,
	setOpenRefundPopup: (open: boolean) => void
) => {
	const editableFields = ['refund.currencyId', 'refund.amount', 'refund.boNotes'];

	if (editableFields.includes(field.props.name)) {
		field.mode = permissionToChangeStatus ? fieldMode.write : fieldMode.readonly;
		field.props.disabled = !permissionToChangeStatus;
	}

	if (field.props.name === 'refund.create') {
		field.props.disabled = !permissionToChangeStatus || !isFormValid;
		if (permissionToChangeStatus) {
			field.mode = fieldMode.write;
			field.props.handleClick = () => setOpenRefundPopup(true);
		}
	}
};

export function getWithdrawalFormsValuesByTypeAndStep(record: Record<string, any>, type: withdrawalBalanceSteps) {
	const form = _.get(withdrawalBalanceTypesForms(), type);
	const obj = {};

	form.fieldsGroups.forEach((group: any) => {
		group.fields.forEach((field: any) => {
			let value = _.get(record, field.props.name, '');

			switch (field.props.name) {
				case 'close_account':
					value = record.type === SupportType.WithdrawalWithClose ? 'true' : 'false';
					break;
				case 'cc_reference':
					value = record.type === BalanceType.Withdrawal ? record.ccId : null;
					break;
				case 'currency_id':
					if (_.has(record, 'associatedCurrency')) {
						value = _.get(record, 'associatedCurrency')?.id;
					}
					break;
				case 'reason':
					value = !_.isEmpty(record.message) ? record.message : value;
					break;
				case 'amount':
					value = value ? value : '';
					break;
				case 'house_account_transfer_amount':
					value = record?.amount || '';
					break;
				case 'house_account_transfer_currency_id':
					value = record?.currencyId || '';
					break;
				case 'altshuler_account_id':
					value = _.isNil(value) ? '' : value;
					break;
				case 'final_altshuler_transfer_account_id':
					value = record?.altshulerAccountId || value;
					break;
				case 'final_altshuler_transfer_currency_id':
					value = record?.currencyId || value;
					break;
				case 'final_altshuler_account_transfer_amount':
					value = record?.amount || value;
					break;
			}
			/*if (field.props.name == 'close_account' && withdrawalBalanceSteps.WITHDRAWAL_INITIAL_REQUEST) {
				value = record.type === SupportType.WithdrawalWithClose ? 'true' : 'false';
			} else if (
				field.props.name == 'cc_reference' &&
				withdrawalBalanceSteps.WITHDRAWAL_ALTSHULER_CC_TO_BANK_ACCOUNT
			) {
				value = record.type === BalanceType.Withdrawal ? record.ccId : null;
			} else {
				value = _.get(record, field.props.name, '');
			}*/

			_.assign(obj, { [field.props.name]: value });
		});
	});

	return obj;
}

export const getCompanyWithdrawalCurrenciesOptions = () => {
	const currencies = store.getState().global.currencies;
	const companyBalances = store.getState().customerAccount.companyDashboard?.balances;
	const companyBalancesOptions = companyBalances?.map((companyBalance: any) => {
		const currencyLabel = currencies?.find((currency: any) => currency.id === companyBalance.currencyId)?.code;
		return {
			label: currencyLabel,
			value: companyBalance.currencyId,
		};
	});
	return companyBalancesOptions;
};
export const getCompanyContactsOptions = () => {
	const companyContacts = store.getState().customerAccount.companyDashboard?.contacts;
	const companyContactsOptions = companyContacts?.map((companyContact: any) => {
		return {
			label: companyContact?.firstNameHebrew + ' ' + companyContact?.lastNameHebrew,
			value: companyContact?.id,
		};
	});
	return companyContactsOptions;
};

export const getCompanyBankAccountsOptions = () => {
	const companyBankAccounts = store.getState().customerAccount.companyDashboard?.bankAccounts;
	const companyBankAccountsOptions = companyBankAccounts
		?.filter((bankAccount: any) => bankAccount.status === BankAccountStatus.Completed)
		?.map((account: any) => {
			return {
				label: `${account.accountNumber} מספר חשבון - ${account.bankBranch} ${account.bankCode} ${account.bankName}`,
				value: account.id,
			};
		});

	return companyBankAccountsOptions;
};

export const getAltshulerAccountsOptions = () => {
	const altshulerAccountsList = store.getState().global.altshulerAccountList;
	const altshulerAccountsOptions = altshulerAccountsList?.map((account: any) => {
		return {
			label: `${account.accountNumber} מספר חשבון - ${account.bankBranch} ${account.bank.bankCode} ${account.bank.bankName}`,
			value: account.id,
		};
	});
	return altshulerAccountsOptions;
};

export const validatePerType = (item: any, type: pendingRequestsTypes, props: any, t: any) => {
	const invalidFields: Record<string, any> = {};
	if (type === pendingRequestsTypes.CONTACTS && _.isArray(props?.contacts)) {
		const identificationNumber = _.get(item, 'identificationNumber');
		const emailAddress = _.get(item, 'emailAddress');
		_.find(props?.contacts, (user) => {
			if (item && _.isEqual(user?.identificationNumber, identificationNumber || '')) {
				invalidFields['identificationNumber'] = {
					valid: false,
					name: 'identificationNumber',
					errorText: _.replace(t('validations.errors.alreadyExist'), '{0}', t('label.identificationNumber')),
				};
			}
			if (item && _.isEqual(user?.email, emailAddress || '')) {
				invalidFields['emailAddress'] = {
					valid: false,
					name: 'emailAddress',
					errorText: _.replace(t('validations.errors.alreadyExist'), '{0}', t('label.email')),
				};
			}
		});
	}
	return invalidFields;
};
